import React, { useContext } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { fontstyle1 } from "../../utils/fonts";
import ThemeContext from "../../context";

const Themetoggler = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <div
      onClick={() => {
        setTheme(theme === "dark" ? "light" : "dark");
        localStorage.setItem("theme", theme === "dark" ? "light" : "dark");
      }}
    >
      {theme === "light" ? (
        <div className="text-xl text-[#FF834F] cursor-pointer flex items-center gap-2">
          <span className="text-base hidden sm:block" style={fontstyle1}>
            Light Mode
          </span>
          <FaSun />
        </div>
      ) : (
        <div className="text-xl text-white cursor-pointer flex items-center gap-2">
          <span className="text-base hidden sm:block" style={fontstyle1}>
            Dark Mode
          </span>
          <FaMoon />
        </div>
      )}
    </div>
  );
};

export default Themetoggler;
